import Sidebar from "./Sidebar";
import Topbar from "./Topbar";

export default function Layout({ breadcrumbs = [], children }) {
  return (
    <div className="flex bg-background min-h-screen">
      <Sidebar />
      <main className="flex-1 min-w-0">
        <Topbar breadcrumbs={breadcrumbs} />
        <div className="px-6 lg:px-8 py-6">{children}</div>
        <footer className="px-6 lg:px-8 py-6 border-t border-border mt-12 text-xs text-muted-foreground">
          Remi8-assisted drafting only. Final approval remains with the authorized
          department officer. Department data will not be used for external
          training without approval.
        </footer>
      </main>
    </div>
  );
}
